<template>
  <div id="detail" class="detail">
    <!-- <div class="back" @click="back"><img src="./img/backup.png" alt=""><span>返回上一页</span></div> -->
    <div style="text-align: center;">
     <img  src="@/assets/serviceImg/service/Frame_4108@2x(6).png">
    </div>
     
    <div class="rich_text">{{ overseasMedicalArrangementCopyText }}</div>
    <div style="width: 100%;height: 11vw;background: rgb(0, 187, 130);border-radius: 20px;text-align: center;line-height: 11vw;color: #ffffff;margin-top: 10vw;font-size: 4vw;display: flex;align-items: center;justify-content: center;" @click="makeanappointment()">获取服务</div>
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p style="margin-bottom: 7vw;">该项权益需开通以下服务权益</p>
        <div style="width:100%;height:40vw;position: relative;" @click="equity()">
          <img style="width: 100%;height: 100%;position: absolute;top: 2vw;" src="@/assets/img/qykbj.png" />
          <div>
             <h3 style="position: absolute;top: 17vw;left: 7vw;font-size: 5vw;">大救星-星健康权益卡</h3>
             <div style="position: absolute;top: 25vw;left: 7vw;color:#666666;font-size: 3.5vw;">多项健康权益尊享，为您健康守护</div>
             <div style="width: 18vw;height: 7vw;font-size: 3vw;line-height: 7vw;color: #F2D57A;text-align: center;background: rgb(74, 71, 64);border-radius: 16px;position: absolute;top: 17vw;right: 4vw;">了解更多</div>
          </div>
        </div>
      </div>
      
    </div>
 </div>
</template>
<script>
import Axios from 'axios'
export default {
  data () {
    return {
      attribute:'',
      src1:'',
      detailText: '',
      showModal:false,
      equityinfoType:false,
    };
  },
  computed: {
    /**
     * 根据 productId 显示海外就医安排页面文案
     * @returns {string}
     */
    overseasMedicalArrangementCopyText() {
      const productId = this.$route.query.productId;
      if (productId === '951' || productId === 951) {
        return '协助用户联系专业机构，7-14个工作日内由专业机构安排美国、德国、英国、日本海外顶级医院就诊，用户提供既往所有的病例资料，协助用户整理并传输病历资料，供专业机构安排海外就医诊疗。由此产生的第三方协调费用、签证费用、接送机费用、医疗费用、翻译费用等，需要用户承担。';
      }
      if (productId === '949' || productId === 949) {
        return '协助被保险人联系专业机构，7-14个工作日内由专业机构安排美国、德国、英国、日本海外顶级医院就诊，被保险人提供既往所有的病例资料，协助被保险人整理并传输病历资料，供专业机构安排海外就医诊疗。由此产生的第三方协调费用，签证费用，接送机费用，医疗费用，翻译费用等，需要被保险人承担。';
      }
      // 默认文案（无 productId 或其他值时）
      return '协助用户联系专业机构，7-14个工作日内由专业机构安排美国、德国、英国、日本海外顶级医院就诊，用户提供既往所有的病例资料，协助用户整理并传输病历资料，供专业机构安排海外就医诊疗。由此产生的第三方协调费用、签证费用、接送机费用、医疗费用、翻译费用等，需要用户承担。（响应时效：2个工作日，服务有效期：7-15个工作日，权益次数：1次）';
    }
  },
  created(){
    document.title = "海外就医安排"
    console.log(localStorage.getItem('equityinfo'))
    this.equityinfoType = localStorage.getItem('equityinfo');
  },
  beforeCreate() {
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  mounted() {
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "48px";
        }
  },
  methods: {
    makeanappointment() {
      this.$router.push({
            name: 'onClickRescue',
            query: {}
        });
      // this.$router.push({
      //   path: "/makeanappointment",
      //   query:{
      //   }
      // });
    },
    equity() {
      this.$router.push({
        path: "/equity",
        query:{
        }
      });
    }
  }
}
</script>
<style scoped >
.modal {
   
   position: fixed; 
   z-index: 1000000; 
   left: 0;
   top: 0;
   width: 100%; 
   height: 100%; 
   overflow: auto; 
   background-color: rgb(0,0,0); 
   background-color: rgba(0,0,0,0.4); 
 }
 .modal-content {
   background-color: #fefefe;
   padding: 8% 5%;
   border-radius: 12px 12px 0px 0px;
   position: absolute;
   bottom: 0;
   width: 100%;
   line-height: 0;
 }
 .close {
   color: #aaa;
   float: right;
   font-size: 28px;
   font-weight: bold;
 }
 .close:hover,
 .close:focus {
   color: black;
   text-decoration: none;
   cursor: pointer;
 }
  .title{
    line-height: 2rem;
    text-align: center;
    margin: 1rem 0;
    border-bottom: none;
    padding: 0;
  }
  h5{
    /* font-size: 1.04166vw; */
    font-weight: normal;
    margin-bottom: 1.04166vw;
  }   
  .rich_text {
    text-indent: 2em;
    width:100%;
    word-wrap: break-word;
  }
  .rich_text >>> img{
    width: 100%;
  }
  .back{
    cursor: pointer;
    margin-bottom: 1.04166vw;
  }
  img{
    width: 100px;
    height: 100px;
    vertical-align: middle;
    margin-right: .5vw;
    margin-bottom: 1rem;
  }
  .rich_text, .rich_text span, .rich_text p, .rich_text strong{
    font-size: 14px!important;
    color: #666!important;
    /* line-height: 1.5rem!important; */
  }
  .detail{
    padding: 1rem 1rem 2rem;
    width: 100%;
    height: auto;
    overflow-x: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/views/detailsH5/overseasMedicalArrangement.vue